import { NgModule } from '@angular/core';
import { IsFeatureFlagEnabledPipe } from './is-feature-flag-enabled.pipe';

@NgModule({
    declarations: [IsFeatureFlagEnabledPipe],
    exports: [IsFeatureFlagEnabledPipe]
})
export class IsFeatureFlagEnabledPipeModule {}
